//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
//@end

//@import components
import ContentInterestModule from 'app_components/modules/newsEvents/contentInterest'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import { routingService } from 'app_services/routingService';
// @end

// @INFO Import Styles
import './../switchInterestModule.scss'

// @ADD Component types
interface ISwitchInterestModuleLayoutProps {
  modules: Array<any>
  hideTitle?: boolean
  hideSubtitle?: boolean
  locations?: Array<string>
}

const SwitchInterestModuleLayout: React.FC<ISwitchInterestModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='switch_interest-component font-title-bold'>
      {!props.hideTitle && <div className="container-title-switch">
        <div className="title">{t('modules.switch_interest.title')}</div>
        <Link
          to={routingService.getPublicPath('/icontec-resources')}
        >
          <ButtonComponent
            variant='secondary'
            className='button-icontec'
          >
            Recursos ICONTEC
          </ButtonComponent>
        </Link>
      </div>}
      {!props.hideSubtitle && <div className="description">{t('modules.switch_interest.description')}</div>}

      {props.modules && props.modules.length > 0 && (
        <Tabs defaultActiveKey={props.modules[0].key} className="nav-fill interest-tabs" mountOnEnter={true}>
          {props.modules.map((module) => (
            <Tab
              eventKey={module.key}
              title={module.title}
              key={`tab-${module.key}`}
              disabled={['blog'].includes(module.key) ? true : false}
            >
              <div className="mt-5">
                <ContentInterestModule key={`content-interest-${module.key}`} module={module} locations={props.locations} />
              </div>
            </Tab>
          ))}
        </Tabs>
      )}
      <div className="buttons-movil-resources">
        {props.modules && props.modules.length ?
          props.modules.map((_mod) => (
            <Link
              to={routingService.getPublicPath(_mod?.view_more?.link)}
              key={_mod.key}
              style={{ width: '100%' }}
            >
              <ButtonComponent
                variant='secondary'
                className='button-resource-option'
              >
                {_mod.title}
              </ButtonComponent>
            </Link>
          ))
        :null}
      </div>
    </div>
  )
}

export default SwitchInterestModuleLayout
